import { Pipe, PipeTransform } from '@angular/core';
import { AlarmAckStyle, MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'alarmAckStyle'
})
export class AlarmAckStylePipe implements PipeTransform {

  transform(alarm: MonitoredTrain): AlarmAckStyle {
    const background = alarm.severity ? this._getSeverityColor(alarm.severity) : '';
    return {
      'background-color': background,
      'color': 'black'
    };
  }

  _getSeverityColor = (index: number) => {
    if (index == -1) {
      return 'grey';
    } else if (index > 7 || index < 0) {
      return '';
    }
    var priorityColors = ["#00FF00", "#D6F6FF", "#F9EFE7", "#F9AB74", "#FA6901", "#FA6901", "black", "#945ABF"];
    return priorityColors[index];
  }

}
